import { ProgramForm } from '../ProgramForm';
import { ProgramDrawerShell } from './ProgramDrawerShell';
import { useDirtyCloseConfirm } from '../../lib/useDirtyCloseConfirm';
import { useUpsertProgram } from '../../lib/useUpsertProgram';
import { formValuesToEditPayload } from '../../model/programForm.mapper';
import { SavedProgram } from '../../api/programForm.response';
import { ProgramFormValues } from '../../model/programForm.types';

type EditProgramDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
  creatorId: number;
  programId: number;
  defaultValues: ProgramFormValues;
  onSaved: (saved: SavedProgram) => void;
  isPublished: boolean;
};

export const EditProgramDrawer = ({
  isOpen,
  onClose,
  creatorId,
  programId,
  defaultValues,
  onSaved,
  isPublished,
}: EditProgramDrawerProps) => {
  const { onDirtyChange, attemptClose } = useDirtyCloseConfirm(onClose);
  const { isSubmitting, handleSave } = useUpsertProgram(
    (values) => formValuesToEditPayload(values, { creatorId, programId }),
    onSaved,
  );

  return (
    <ProgramDrawerShell
      isOpen={isOpen}
      onClose={attemptClose}
      title="Edit program"
      testId="edit-program-drawer"
    >
      <ProgramForm
        defaultValues={defaultValues}
        submitLabel="Save"
        isSubmitting={isSubmitting}
        creatorId={creatorId}
        programId={programId}
        onSave={handleSave}
        onDirtyChange={onDirtyChange}
        isPublished={isPublished}
      />
    </ProgramDrawerShell>
  );
};
